import { render, staticRenderFns } from "./WaitingStatuses.vue?vue&type=template&id=3b678a0c&scoped=true&"
import script from "./WaitingStatuses.vue?vue&type=script&lang=js&"
export * from "./WaitingStatuses.vue?vue&type=script&lang=js&"
import style0 from "./WaitingStatuses.vue?vue&type=style&index=0&id=3b678a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b678a0c",
  null
  
)

export default component.exports